import http from "plugins/axios";

export default {
  // 获取列表
  getList(data) {
    return http.get({
      url: "/admin/tradePairTip/list",
      data,
    });
  },
  // 新增胡总编辑
  addOrUpdate(data) {
    return http.post({
      url: "/admin/tradePairTip/addOrUpdate",
      data,
    });
  },
  // 删除内容
  deleteData(data) {
    return http.post({
      url: "/admin/tradePairTip/delete",
      data,
      dataType: "form",
    });
  },
  //   获取交易对
  getTradePairMap(data) {
    return http.get({
      url: "/admin/tradePairTip/tradePairMap",
    });
  },
  //   获取已配置的交易对
  getConfigPair(data) {
    return http.get({
      url: "/admin/tradePairTip/haveConfigPair/list",
    });
  },
};
